export const naturezaOperacaoOptions = [
    { value: '1', text: 'Devolução'},
    { value: '2', text: 'Venda'},
    { value: '3', text: 'Troca'}
]